window.HessDiscountPricing = {
  generatedAt: "2026-09-27T12:00:00+02:00",
  rules: [
    {
      id: "automatic-katalog",
      automatic: true,
      discount: { type: "percentage", value: 100 },
      minimumQuantity: 1,
      targets: {
        products: ["7197766156375", "15385227460985"],
      },
    },
    {
      id: "code-product",
      codes: ["PRODUCT"],
      discount: { type: "percentage", value: 5 },
      targets: {
        products: ["7045507645527"],
      },
    },
    {
      id: "code-simonehartmann10",
      codes: ["SIMONEHARTMANN10"],
      discount: { type: "percentage", value: 10 },
      targets: {
        products: ["7045508399191"],
        variants: ["40802338734167", "40802338766935"],
      },
    },
    {
      id: "bulk-newsletter10",
      codePrefixes: ["NEWSLETTER-10-"],
      discount: { type: "percentage", value: 10 },
      targets: {
        collections: [
          "274699976791", "274780913751", "274793693271", "274793726039", "274793758807",
          "274793824343", "274793922647", "275200868439", "275200901207", "275203194967",
          "275203555415", "275203588183", "275203620951", "275203686487", "275203752023",
          "275203817559", "275203883095", "275226132567", "275226165335", "275226230871",
          "275226296407", "275226329175", "275232620631", "275232686167", "275232784471",
          "275232850007", "275232882775", "275232981079", "275233013847", "275233079383",
          "275233177687", "275233210455", "275233243223", "275233308759", "275233341527",
          "275233407063", "275233472599", "275233538135", "275233570903", "275233603671",
          "275233636439", "275233669207", "275233767511", "275233800279", "275233865815",
          "275233898583", "275233931351", "275234062423", "275234160727", "275234193495",
          "275294257239", "275631669335", "275631734871", "275631767639", "275631800407",
          "667402830201", "667753054585", "676948115833", "676948181369", "679848640889",
          "687060386169",
        ],
      },
    },
    {
      id: "code-bxpe6z1yg134",
      codes: ["BXPE6Z1YG134"],
      discount: { type: "percentage", value: 10 },
      targets: {
        collections: [
          "274699649111", "274699976791", "274780913751", "274793693271", "274793726039",
          "274793758807", "274793824343", "274793922647", "275200868439", "275200901207",
          "275203194967", "275203555415", "275203588183", "275203620951", "275203686487",
          "275203752023", "275203817559", "275203883095", "275226132567", "275226165335",
          "275226230871", "275226296407", "275232686167", "275232718935", "275232751703",
          "275232784471", "275232850007", "275232882775", "275232981079", "275233013847",
          "275233177687", "275233210455", "275233243223", "275233341527", "275233407063",
          "275233472599", "275233538135", "275233570903", "275233603671", "275233636439",
          "275233669207", "275233767511", "275233800279", "275233865815", "275233898583",
          "275233931351", "275234062423", "275234160727", "275234193495", "275631669335",
          "275631734871", "275631767639", "275631800407", "278899228759", "667402830201",
          "667753054585", "676948181369", "679848640889", "687060386169",
        ],
      },
    },
    {
      id: "code-sale40",
      codes: ["SALE-40"],
      discount: { type: "percentage", value: 40 },
      targets: {
        products: ["7016990670935"],
      },
    },
    {
      id: "bulk-missyou10",
      codePrefixes: ["MISSYOU10"],
      discount: { type: "percentage", value: 10 },
      targets: {
        collections: [
          "274699976791", "274780913751", "274793693271", "274793726039", "274793758807",
          "274793824343", "274793922647", "275200868439", "275200901207", "275203194967",
          "275203555415", "275203588183", "275203620951", "275203686487", "275203752023",
          "275203817559", "275203883095", "275226132567", "275226165335", "275226230871",
          "275226296407", "275226329175", "275232850007", "275232882775", "275232981079",
          "275233013847", "275233079383", "275233177687", "275233210455", "275233243223",
          "275233308759", "275233341527", "275233407063", "275233472599", "275233538135",
          "275233570903", "275233603671", "275233636439", "275233669207", "275233767511",
          "275233800279", "275233865815", "275233898583", "275233931351", "275234062423",
          "275234160727", "275234193495", "275631669335", "275631734871", "275631767639",
          "275631800407", "667753054585", "679848640889", "687060386169", "689965171065",
        ],
      },
    },
    {
      id: "code-andrea-klotz-5",
      codes: ["ANDREA-KLOTZ-5"],
      discount: { type: "percentage", value: 5 },
      targets: {
        collections: ["274699976791"],
      },
    },
    {
      id: "code-melanie-otte-10",
      codes: ["MELANIE-OTTE-10"],
      discount: { type: "percentage", value: 10 },
      targets: {
        collections: [
          "274699976791", "274793693271", "274793824343", "275232620631", "275232686167",
          "275232882775", "275233243223", "275233308759", "275233407063", "275233472599",
          "275233538135", "275233570903", "275233603671", "275233767511", "275233800279",
          "275233865815", "275233898583", "275631669335", "275631734871", "275631767639",
          "275631800407", "679848640889", "693036286329", "693036384633", "693036417401",
          "693036515705", "694125134201",
        ],
      },
    },
    {
      id: "code-foundrise",
      codes: ["FOUNDRISE"],
      discount: { type: "percentage", value: 15 },
      targets: {
        collections: ["274699976791"],
      },
    },
    {
      id: "code-travel-30",
      codes: ["TRAVEL-30"],
      discount: { type: "fixed_amount", value: 3000 },
      targets: {
        variants: ["55013361353081"],
      },
    },
    {
      id: "code-tryp-10",
      codes: ["TRYP-10"],
      discount: { type: "percentage", value: 10 },
      targets: {
        collections: [
          "274699976791", "274780913751", "274793693271", "275203588183", "275203620951",
          "275203686487", "275232850007", "275233013847", "275233472599",
        ],
      },
    },
    {
      id: "bulk-5off-all",
      codePrefixes: ["5%OFF-"],
      discount: { type: "percentage", value: 5 },
      targets: {
        all: true,
      },
    },
    {
      id: "bulk-newsletter10-all",
      codePrefixes: ["NEWSLETTER-10-", "RABATT_NEWSLETTER_10"],
      discount: { type: "percentage", value: 10 },
      targets: {
        all: true,
      },
    },
    {
      id: "code-apollohalley20",
      codes: ["APOLLOHALLEY20"],
      discount: { type: "percentage", value: 20 },
      targets: {
        all: true,
      },
    },
    {
      id: "code-didacta2026",
      codes: ["DIDACTA2026"],
      discount: { type: "percentage", value: 10 },
      targets: {
        all: true,
      },
    },
    {
      id: "code-cendra05",
      codes: ["CENDRA05"],
      discount: { type: "percentage", value: 5 },
      targets: {
        all: true,
      },
    },
    {
      id: "automatic-deep-season-20",
      automatic: true,
      startsAt: "2026-09-20T08:00:00Z",
      endsAt: "2026-10-04T21:59:59Z",
      cartTitles: ["20% DEEP SEASON"],
      excludeB2B: true,
      discount: { type: "percentage", value: 20 },
      targets: {
        products: [
          "7016991031383", "7016997453911", "7017001287767", "7045507645527",
          "7045508399191", "7045535400023", "7116049350743", "14910264279417",
          "15238605603193", "15325338173817", "15355306082681", "15521162166649",
          "15798969106809", "15799109157241",
        ],
        variants: [
          "40575435079767", "40575461556311", "40575461589079", "40575461621847",
          "40575461654615", "40575461883991", "40575461916759", "40575520178263",
          "40575585091671", "40679953694807", "40802338734167", "40802345222231",
          "40802354495575", "40835641638999", "40835641671767", "40835647995991",
          "41129108963415", "55013362467193", "55340075909497", "55348286882169",
          "55349099168121", "55349099266425", "55397898289529", "55397901140345",
          "55397901795705", "55424573211001", "55572383760761", "55670923788665",
          "56351780602233", "56351781093753", "56833242333561",
        ],
      },
    },
    {
      id: "automatic-deep-season-10",
      automatic: true,
      startsAt: "2026-09-25T12:35:00Z",
      endsAt: "2026-10-04T21:59:59Z",
      cartTitles: ["10% DEEP SEASON"],
      excludeB2B: true,
      discount: { type: "percentage", value: 10 },
      targets: {
        variants: ["40802338766935", "40802345254999", "40802354528343", "40835647963223"],
      },
    },
    {
      id: "automatic-ske-10",
      automatic: true,
      startsAt: "2026-06-25T22:01:52Z",
      endsAt: "2026-06-28T21:59:59Z",
      cartTitles: ["SKE-10", "SKE-10 TEIL 2", "SKE-10 TEIL 3"],
      discount: { type: "percentage", value: 10 },
      targets: {
        products: [
          "7016986214487", "7016986247255", "7016986345559", "7016986476631", "7016986542167",
          "7016987099223", "7016990376023", "7016990670935", "7016990998615", "7016991031383",
          "7016992047191", "7016992604247", "7016992931927", "7016993751127", "7016994373719",
          "7016996995159", "7016997322839", "7016997355607", "7016997388375", "7016997453911",
          "7016997519447", "7016997584983", "7016997781591", "7017001156695", "7017001287767",
          "7017002827863", "7017003024471", "7017003090007", "7017003155543", "7017003417687",
          "7017003614295", "7017003679831", "7017003810903", "7017003909207", "7017004007511",
          "7017005154391", "7017005219927", "7017018818647", "7017018916951", "7017019572311",
          "7017019637847", "7017019703383", "7017019768919", "7017020031063", "7017020063831",
          "7017020129367", "7017023373399", "7017023406167", "7017023471703", "7017023668311",
          "7017023733847", "7017023766615", "7017023930455", "7017024028759", "7017024159831",
          "7017024225367", "7017024258135", "7017024356439", "7017024389207", "7017024421975",
          "7017024454743", "7017024618583", "7017024880727", "7017025962071", "7017026158679",
          "7017027338327", "7017028223063", "7017028386903", "7017028747351", "7017028911191",
          "7017029075031", "7017029206103", "7017029337175", "7017029533783", "7017029566551",
          "7017029763159", "7017030680663", "7017031008343", "7017031172183", "7017032122455",
          "7017032155223", "7017033302103", "7017035202647", "7017036939351", "7017042313303",
          "7017042378839", "7017042509911", "7017042542679", "7017042640983", "7017043001431",
          "7017043066967", "7017043198039", "7017043230807", "7017043296343", "7017043689559",
          "7017043853399", "7017043951703", "7017044017239", "7017044508759", "7017044705367",
          "7017045065815", "7017048932439", "7017049817175", "7017049882711", "7017050079319",
          "7017050177623", "7017050374231", "7017050996823", "7017051062359", "7017051586647",
          "7017051619415", "7039603834967", "7044776067159", "7045506498647", "7045507022935",
          "7045507481687", "7045507645527", "7045508399191", "7045523374167", "7045535400023",
          "7096607146071", "7096617205847", "7107570303063", "7107571482711", "7116006260823",
          "7116007014487", "7116049350743", "7247749546071", "7247750430807", "7262860443735",
          "7287998971991", "7293845143639", "7293852221527", "7293870374999", "7295014731863",
          "7295301976151", "14654944215417", "14845918609785", "14850795045241",
          "14858144743801", "14890501308793", "14890502783353", "14908591669625", "14910263951737",
          "14910264115577", "14910264148345", "14910264279417", "14910700257657", "14915914498425",
          "14915914891641", "14918777667961", "14920763605369", "14920763801977", "14946734571897",
          "14966201647481", "14966245032313", "14973418013049", "15004546400633", "15004547023225",
          "15024769892729", "15026225676665", "15050376446329", "15070093803897", "15070095343993",
          "15074607464825", "15136195576185", "15136235028857", "15136249479545", "15136255738233",
          "15136268845433", "15136283066745", "15136315769209", "15153115824505", "15153433149817",
          "15160329175417", "15160420204921", "15161202508153", "15232264438137", "15232754712953",
          "15237375459705", "15237415174521", "15238584992121", "15238605603193", "15248892559737",
          "15250283463033", "15250299519353", "15263773294969", "15264704299385", "15268051976569",
          "15274632315257", "15274650403193", "15274663575929", "15274873520505", "15274890101113",
          "15274913825145", "15316638695801", "15325338173817", "15325732766073", "15343626355065",
          "15343628190073", "15343705948537", "15350133555577", "15350138241401", "15352263344505",
          "15355306082681", "15355722367353", "15364027842937", "15404288442745", "15419047575929",
          "15419361034617", "15427119776121", "15427122135417", "15427124494713", "15479360258425",
          "15488321257849", "15489217823097", "15521065107833", "15521162166649",
        ],
      },
    },
    {
      id: "automatic-sale20",
      automatic: true,
      discount: { type: "percentage", value: 20 },
      targets: {
        products: ["7016990670935", "7016992047191", "7016992931927", "7017003024471"],
      },
    },
  ],
};
